import { createAction, props } from '@ngrx/store';
import { IAiConversation, IAiConversationSummary } from '../models/ai-chat.models';

// ─── Drawer ───────────────────────────────────────────────────────────────────

export const ToggleAiChatDrawer = createAction('[ AI Chat ] - ToggleAiChatDrawer');

export const SetAiChatDrawerOpen = createAction(
  '[ AI Chat ] - SetAiChatDrawerOpen',
  props<{ open: boolean }>()
);

// ─── Conversation list ────────────────────────────────────────────────────────

export const LoadConversations = createAction('[ AI Chat ] - LoadConversations');

export const LoadConversationsSuccess = createAction(
  '[ AI Chat ] - LoadConversations Success',
  props<{ conversations: IAiConversationSummary[] }>()
);

export const LoadConversationsFailure = createAction('[ AI Chat ] - LoadConversations Failure');

// ─── Active conversation ──────────────────────────────────────────────────────

export const SelectConversation = createAction(
  '[ AI Chat ] - SelectConversation',
  props<{ id: string }>()
);

export const SelectConversationSuccess = createAction(
  '[ AI Chat ] - SelectConversation Success',
  props<{ conversation: IAiConversation }>()
);

export const SelectConversationFailure = createAction('[ AI Chat ] - SelectConversation Failure');

// ─── Draft ────────────────────────────────────────────────────────────────────

export const CreateDraftConversation = createAction('[ AI Chat ] - CreateDraftConversation');

export const CreateDraftConversationSuccess = createAction(
  '[ AI Chat ] - CreateDraftConversation Success',
  props<{ conversation: IAiConversation }>()
);

/** Fired after the first send on a draft — maps the local draft id to the real server id (session_id). */
export const ResolveDraftConversation = createAction(
  '[ AI Chat ] - ResolveDraftConversation',
  props<{ realId: string }>()
);

// ─── Delete ───────────────────────────────────────────────────────────────────

export const DeleteConversation = createAction(
  '[ AI Chat ] - DeleteConversation',
  props<{ id: string }>()
);

export const DeleteConversationSuccess = createAction(
  '[ AI Chat ] - DeleteConversation Success',
  props<{ id: string }>()
);

export const DeleteConversationError = createAction('[ AI Chat ] - DeleteConversation Error');

// ─── Messaging ────────────────────────────────────────────────────────────────

export const SendMessage = createAction(
  '[ AI Chat ] - SendMessage',
  props<{ text: string }>()
);

export const SendMessageSuccess = createAction(
  '[ AI Chat ] - SendMessage Success',
  props<{ conversation: IAiConversation }>()
);

export const SendMessageError = createAction('[ AI Chat ] - SendMessage Error');
